import { createSlice } from '@reduxjs/toolkit';

export const companySlice = createSlice({
    name: 'company',
    initialState: {
        dataToAction: { name: '', cif: '', address: '', zipCode: '', country: '', iban: '', swift: '' }
    },
    reducers: {
        selectCompany: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectCompany: (state) => {
            state.dataToAction = {
                userToAction: { name: '', cif: '', address: '', zipCode: '', country: '', iban: '', swift: '' }
            }
        }
    }
});

export const { selectCompany, unSelectCompany } = companySlice.actions;